var exports = {
  "u": "StickersPicker.module__searchResultsContainer___SHM1SX",
};

module.exports = exports;
